import React, { useEffect } from "react";
import "./App.css";
import axios from "axios";
import { Navigation } from "./components/Navigation";
import { Hero } from "./components/Hero";
import { RestaurantPhotosSection } from "./components/RestaurantPhotosSection";
import { PromoSection } from "./components/PromoSection";
import { MenuSection } from "./components/MenuSection";
import { InfoSection } from "./components/InfoSection";
import { AboutSection } from "./components/AboutSection";
import { GallerySection } from "./components/GallerySection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
    
    // Remove Emergent badge
    const removeBadge = () => {
      const badge = document.getElementById('emergent-badge');
      if (badge) {
        badge.remove();
      }
    };
    
    // Try immediately and after a delay (for dynamically injected badges)
    removeBadge();
    const timeoutId = setTimeout(removeBadge, 1000);
    const intervalId = setInterval(removeBadge, 2000);
    
    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div className="App">
      <Navigation />
      <Hero />
      <RestaurantPhotosSection />
      <PromoSection />
      <MenuSection />
      <InfoSection />
      <AboutSection />
      <GallerySection />
      <ContactSection />
      <Footer />
    </div>
  );
}

export default App;
